export default {
  narrow: {
    thickness: '0.0625rem',
  },
  normal: {
    thickness: '0.125rem',
  },
  wide: {
    thickness: '0.1875rem',
  },
  margin: {
    top: '0.9375rem',
    bottom: '0.9375rem',
  },
};
